import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Select from "react-select";
import ToggleSwitch from "./ToggleSwitch";
import "../styles/questionnaire.css";

export default function QuestionnaireV2({ isOpen, onSubmit, isResizeAndCropReady = false, version = 1 }) {
  const [data, setData] = useState({
    cough: null,
    headache: null,
    weakness: null,
    sore_throat: null,
    recovered: null,
    exposed: "",
  });

  const onClick = () => {
    onSubmit({
      cough: data.cough ? "True" : "False",
      headache: data.headache ? "True" : "False",
      weakness: data.weakness ? "True" : "False",
      sore_throat: data.sore_throat ? "True" : "False",
      recovered: data.recovered ? "True" : "False",
      exposed: data.exposed,
    });
  };

  const isQuestionSelected = () => {
    if (version === 2 && !isResizeAndCropReady) return true;
    if (data.exposed === "") return true;
    if (data.cough === null) return true;
    if (data.headache === null) return true;
    if (data.weakness === null) return true;
    if (data.sore_throat === null) return true;
  };

  return (
    <>
      <Modal animation={false} show={isOpen} centered backdrop="static" className="questionnaire_modal">
        <Modal.Header>
          <Modal.Title>Questionnaire</Modal.Title>
        </Modal.Header>
        <Modal.Body className="body">
          <div className="content" data-testid="questionnaire_body">
            <ul>
              <li>
                <div className="d-flex justify-content-between my-1">
                  <div>Were you exposed to someone who may have COVID-19 in the last 14 days?</div>
                  <div className="exposed-option">
                    <Select
                      id="exposed"
                      data-testid="exposed"
                      defaultValue={data.exposed}
                      onChange={(option) => {
                        console.log(option);
                        setData({ ...data, exposed: option?.value });
                      }}
                      isSearchable={false}
                      options={[
                        { value: "True", label: "Yes" },
                        { value: "False", label: "No" },
                        { value: "Unsure", label: "Unsure" },
                      ]}
                    />
                  </div>
                </div>
              </li>
              <li>
                Do you have any of the following symptoms?
                <ol type="a">
                  <li className="symptom">
                    <div className="d-flex justify-content-between my-1">
                      Cough
                      <ToggleSwitch
                        id="cough"
                        dataTestId="toggle_switch_cough"
                        onChange={(v) => setData({ ...data, cough: v })}
                      />
                    </div>
                  </li>
                  <li className="symptom">
                    <div className="d-flex justify-content-between my-1">
                      Headache
                      <ToggleSwitch
                        id="headache"
                        dataTestId="toggle_switch_headache"
                        onChange={(v) => setData({ ...data, headache: v })}
                      />
                    </div>
                  </li>
                  <li className="symptom">
                    <div className="d-flex justify-content-between my-1">
                      Weakness and muscle pain
                      <ToggleSwitch
                        id="weakness"
                        dataTestId="toggle_switch_weakness"
                        onChange={(v) => setData({ ...data, weakness: v })}
                      />
                    </div>
                  </li>

                  <li className="symptom">
                    <div className="d-flex justify-content-between my-1">
                      Sore throat
                      <ToggleSwitch
                        id="sore_throat"
                        dataTestId="toggle_switch_sore_throat"
                        onChange={(v) => setData({ ...data, sore_throat: v })}
                      />
                    </div>
                  </li>
                </ol>
              </li>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          {version === 1 ? (
            <Button
              variant="primary"
              onClick={onClick}
              className="que-submit"
              data-testid="que-submit"
              disabled={isQuestionSelected()}
            >
              Submit
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={onClick}
              className="que-submit"
              data-testid="que-submit"
              disabled={isQuestionSelected()}
            >
              {isResizeAndCropReady ? "Submit" : "Validating images, please wait"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}
